// eslint-disable-next-line import/no-anonymous-default-export
export default (ts) => {
    const date = new Date(parseInt(ts) / 10000);
    const minutes = date.getMinutes()< 10 ? `${0}${date.getMinutes()}` : date.getMinutes()
    const get_hour = date.getHours() > 12 ? date.getHours() - 12 : date.getHours() //get hour Format 12
    const ampm = date.getHours() >= 12 ? 'PM' : 'AM';
    var houradd = get_hour < 10 ? `${0}${get_hour}` : get_hour  //format 01:01
    return `${houradd}:${minutes} ${ampm}`;
  };